import React from 'react';
import OrderCard from './OrderCard';

const OrderList = ({ orders, allMarketData, onCardClick, activeTab }) => {
    if (orders?.length === 0) {
        return (
            <div className="text-center text-gray-500 mt-4">
                <div className="flex flex-col h-full">
                    <img
                        className="mb-5 max-w-full h-auto align-top"
                        src={`${process.env.PUBLIC_URL}/10018100.webp`}
                        alt="logo"
                    />
                </div>
                No orders found
            </div>
        );
    }

    return (
        <div className="flex flex-col gap-4 mb-24">
            {orders?.map((order, index) => (
                <OrderCard
                    key={order.id ?? index}
                    order={order}
                    allMarketData={allMarketData}
                    onClick={onCardClick}
                    activeTab={activeTab}
                />
            ))}
        </div>
    );
};

export default OrderList;